module.exports = __webpack_public_path__ + "media/images/landing/ar/manage@2x-1017fff3094d0a341b0fd635d21b126c.png";